<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Anfrage
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          Einzelcoaching Anfrage
        </h5>

        <Search
            :filters="filters"
            :loading="isSearching"
            :officeDropdown="officeDropdown"
            :userDropdown="userDropdown"
            @search="getListForCoach"/>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Status</th>
              <th>Maßnahmenart</th>
              <th>JC/AA Nr</th>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Standort</th>
              <th>Sachbearbeiter</th>
              <th>Start</th>
              <th>Ende</th>
              <th>Stand</th>
              <th style="text-align: center; padding-right: 30px; min-width: 150px;">
                {{ $t('general.actions') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(coaching) in coachingInquiryList" :key="coaching.id">
              <td>{{ coaching?.statusTranslated }}</td>
              <td>{{ coaching?.nameOfCoaching?.operationTypeTranslated }}</td>
              <td>{{ coaching?.unemployed?.aaNumber }}</td>
              <td>{{ coaching?.unemployed?.firstName }}</td>
              <td>{{ coaching?.unemployed?.lastName }}</td>
              <td>
                <template v-for="(location, index) in coaching.locations" :key="index">
                  {{ location.name }}
                </template>
              </td>
              <td>{{ coaching?.clerk }}</td>
              <td>{{ coaching?.startDate }}</td>
              <td>{{ coaching?.endDate }}</td>
              <td>{{ coaching?.unitsDone }}</td>
              <td class="text-center">
                <button class="btn btn-primary" @click="router.push({
                  name: 'privateCoachingInquiryDetails', params: { id: coaching.id } })">
                  Einzelheiten zur Anfrage
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import {
  getOfficeDropdown,
  getUsersForCoordinatorOverviewDropdown,
} from '@/shared/dropdowns';
import Search from '@/views/App/Unemployed/Coaching/PrivateCoaching/InquiryOverview/Search.vue';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }               = useI18n();
const coachingInquiryList = ref([]);
const filters             = ref({
  officeId: '',
  coachId: '',
  orderBy: 'DESC',
  sortBy: '',
});

const isSearching    = ref(false);
const isLoaded       = ref(false);
const officeDropdown = ref([]);
const userDropdown   = ref([]);

async function getListForCoach(page = 1, perPage, passedFilters) {
  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachingInquiryList.value?.pagination?.items_per_page;

  try {
    const { data } = await privateCoachingService.getInquiryOverviewListForCoach({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    coachingInquiryList.value = data.data;
    isSearching.value         = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  CloseToast();
  await Promise.all([
    getOfficeDropdown(officeDropdown, t),
    getUsersForCoordinatorOverviewDropdown(userDropdown, 'true'),
    getListForCoach(),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>

</style>